module.exports = __webpack_public_path__ + "static/media/declaration_de_sante.c4ab0980.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/data/products/aa/documents/adhesion/declaration_de_sante.pdf
// module id = 815
// module chunks = 40